import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EndPointService {

  /** User Login information */
  getMenuMapping = 'Account/GetLoggedInUserDetail';


  /** Administrative Menu urls  */

  /** Security URLs */
  getApplicationSecurityItems = 'SecurityItems/GetApplicationSecurityItems';
  updateSecurityItem = 'SecurityItems/UpdateSecurityItem';

  /** Responsibilities URLS */
  getResponsibilities = 'Responsibilities/GetResponsibilities';
  addResponsibility = 'Responsibilities/AddResponsibility';
  updateResponsibility = 'Responsibilities/UpdateResponsibility';
  getSecuritiesByResponsibility = 'Responsibilities/GetSecuritiesByResponsibility';
  addSecurityItem = 'Responsibilities/AddSecurityItem';
  updateResponsibilitySecurityItem = 'Responsibilities/UpdateSecurityItem';
  deleteSecurityItem = 'Responsibilities/DeleteSecurityItem';

  /** Project Type URLS */
  getProjectType = 'ProjectTypes/GetProjectTypes';
  getProjectTypeColumn = 'ProjectTypes/GetProjectTypeColumn';
  getProjectTypeRequirement = 'ProjectTypes/GetProjectTypeRequirement';
  addProjectType = 'ProjectTypes/AddProjectType';
  updateProjectType = 'ProjectTypes/UpdateProjectType';
  deleteProjectType = 'ProjectTypes/DeleteProjectType';
  addProjectTypeReq = 'ProjectTypes/AddProjectTypeRequirement';
  updateProjectTypeReq = 'ProjectTypes/UpdateProjectTypeRequirement';
  deleteProjectTypeReq = 'ProjectTypes/DeleteProjectTypeRequirement'; // todo this is not in use
  getProjectTypeLookupData = 'Lookup/GetProjectTypes';  // todo: this api is repeated in this file

  /** LLW Project Report */
  searchLlwProjects = 'LlwProject/SearchLlwProjects';
  getReadyForLlwProjects = 'LlwProject/GetReadyForLlwProjects';
  createLlwProject = 'LlwProject/CreateLlwProject';
  getLlwDetailReport = 'LlwProject/GetLlwProjectDetail';
  getLlwProjectMode = 'LlwProject/GetLlwProjectMode';

  /** GrantsTemplateMapping */
  getGrantsTemplateMapping = 'GrantsTemplateMapping/GetGrantsTemplateMap';
  addGrantsTemplateMapping = 'GrantsTemplateMapping/AddGrantsTemplateMap';
  updateGrantsTemplateMapping = 'GrantsTemplateMapping/UpdateGrantsTemplateMap';
  deleteGrantsTemplateMapping = 'GrantsTemplateMapping/DeleteGrantsTemplateMap';

  // **Maintenance*/
  getAllActivities = 'Activity/GetAllActivity';
  addActivities = 'Activity/AddActivity';
  updateActivities = 'Activity/UpdateActivity';

  // Lookup service
  getApplications = 'Lookup/GetApplications';
  getAllGeoDist = 'Lookup/GetAllGeoDist';
  getInspectors = 'Lookup/GetInspectors';
  getApplicationResponsibilities = 'Lookup/GetApplicationResponsibilities';
  getSecurityItems = 'Lookup/GetSecurityItems';
  getProjectTypesListURL = 'Lookup/GetProjectTypes';
  getPlanCategories = 'Lookup/GetPlanCategories';
  getDsfCategory = 'Lookup/GetDsfCategory';
  getLegislativeCategory = 'Lookup/GetLegislativeCategory';
  getResponsibilitiesList = 'Lookup/GetResponsibilities';
  getProjectStatus = 'Lookup/GetProjectStatus';
  getCapCat = 'Lookup/GetCapCat';
  getSchoolDistIntake = 'Lookup/GetSchoolDistIntake';
  getMainJobDesc = 'Lookup/GetMainJobDesc';
  getSubJobDesc = 'Lookup/GetSubJobDesc';
  getDisposeReason = 'Lookup/GetDisposalReasonCode';
  getContractCategory = 'Lookup/GetContractCategory';
  getPriority = 'Lookup/GetPriority';
  getManagedBy = 'Lookup/GetManagedBy';
  getAdditionalWork = 'Lookup/GetAdditionalWork';
  getRequestor = 'Lookup/GetRequestor';
  getFeCategory = 'Lookup/GetFeCategoryCode';
  getPreKType = 'Lookup/GetPreKType';
  getProjectLlw = 'Lookup/GetProjectLlw';
  getBldgId = 'Lookup/GetBldgId';
  getPassportWorkOrderNumber = 'Lookup/GetPassportWorkOrderNumber';
  getSchoolLevel = 'Lookup/GetSchoolLevel';
  getFundingSourceCode = 'Lookup/GetFundingSourceCode';
  getActivityType = 'Lookup/GetActivityType';
  getDsfTag = 'Lookup/GetDsfTag';
  getCapitalPlanNode = 'Lookup/GetCapitalPlanNode';
  getProgCategory = 'Lookup/GetProgCategory';
  getOrgCodeByBuildingId = 'Lookup/GetOrgCodeByBuildingId';
  getIehInspectorName = 'Lookup/GetIehInspectorName';
  getManagementType = 'Lookup/GetManagementType';
  getDispositions = 'Lookup/GetDispositions';
  getDSFManagerCodes = 'Lookup/GetDSFManagerCodes';


  // Ieh-Inspector service
  getIehInspectorsItems = 'IehInspector/GetIehInspectors';
  updateIehInspectorsItem = 'IehInspector/UpdateIehInspector';
  addIehInspector = 'IehInspector/AddIehInspector';

  // Notification service
  getNotifications = 'Notification/GetNotifications';
  updateNotification = 'Notification/UpdateNotification';
  addNotification = 'Notification/AddNotification';


  // Code Categories service
  getCodeCategories = 'CodeCategories/GetCodeCategories';
  addCodeCategory = 'CodeCategories/AddCodeCategory';
  updateCodeCategory = 'CodeCategories/UpdateCodeCategory';
  getCodeValues = 'CodeCategories/GetCodeValues';
  addCodeValue = 'CodeCategories/AddCodeValue';
  updateCodeValue = 'CodeCategories/UpdateCodeValue';

  // Maintenance > user
  getUsers = 'Users/GetUsers';
  updateUsers = 'Users/UpdateUser';
  addUsers = 'Users/AddUser';
  getUsersResponsibilities = 'Users/GetUserResponsibilities';
  updateUsersResponsibilities = 'Users/UpdateUserResponsibility';
  addUsersResponsibilities = 'Users/AddUserResponsibility';

  // Reports
  getDsfProjectReport = 'Report/DsfProjectReport';
  getDsfApprovalPendingReport = 'Report/DsfApprovalPendingReport';
  getDsfApprovedScaPendingReport = 'Report/DsfApprovedScaPendingReport';
  getScaApprovedReport = 'Report/ScaApprovedReport';
  getScaRejectedReport = 'Report/ScaRejectedReport';
  getCreateLLWReport = 'Report/CreateLlwReport';
  po18NightlyTransactionReport = 'Report/Po18NightlyTransactionReport';
  getLlwExportReport = 'Report/GetLlwExportReport';

  // Capital Category Service

  addPlanCategories = 'CapitalCategoryFunding/AddPlanCategories';
  updatePlanCategories = 'CapitalCategoryFunding/UpdatePlanCategories';

  getPlanSubCategories = 'CapitalCategoryFunding/GetPlanSubCategories';
  addPlanSubCategories = 'CapitalCategoryFunding/AddPlanSubCategories';
  updatePlanSubCategories = 'CapitalCategoryFunding/UpdatePlanSubCategories';

  getCapitalCategory = 'CapitalCategoryFunding/GetCapitalCategory';
  addCapitalCategory = 'CapitalCategoryFunding/AddCapitalCategory';
  updateCapitalCategory = 'CapitalCategoryFunding/UpdateCapitalCategory';

  getFundingSource = 'CapitalCategoryFunding/GetFundingSource';
  addFundingSource = 'CapitalCategoryFunding/AddFundingSource';
  updateFundingSource = 'CapitalCategoryFunding/UpdateFundingSource';

  // Project
  getProjects = 'Project/GetProjects';
  getProjectByWorkOrderNumber = 'Project/GetProjectByWorkOrderNumber';
  getProjectStatusHistory = 'Project/GetProjectStatusHistory';
  getProjectValidationList = 'Project/GetProjectValidationList';
  disposeProject = 'Project/DisposeProject';
  releaseToOspProject = 'Project/ReleaseToOspProject';
  approveProject = 'Project/ApproveProject';
  addProject = 'Project/AddProject';
  updateProject = 'Project/UpdateProject';
  validateCapCategory = 'Project/validateCapCatByBuildingId';
  getProjectMode = 'Project/GetProjectMode';

  // Project Details
  getProjectDetails = 'Project/GetProjectDetail';

  // LLW Exports
  // Error Logs
  getErrorLogs = 'LlwExport/GetErrorLogs';
  getLlwExportRecords = 'LlwExport/GetLlwExportRecords';
  getEnfoExportRecords = 'LlwExport/GetEnfoExportRecords';

  isEnfoExportRunning = 'LlwExport/IsEnfoExportRunning';
  isLlwExportRunning = 'LlwExport/IsLlwExportRunning';
  initiateLlw = 'LlwExport/InitiateLlw';
  initiateEnfo = 'LlwExport/InitiateEnFo';

  hubConnectionUrl = 'LlwExport';
}


